import { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@cld/button-next';
import { AppContext } from './AppContext';
import { CldMediaCards } from './CldMediaCards';
import defaultTheme from '@cld/themes';
import { useDebouncedCallback } from 'use-debounce';
import { useToast } from "@shopify/app-bridge-react";
import Back from './assets/arrow.svg'
import {Cloudinary} from "@cloudinary/url-gen";
import {default as Loading} from './AppLoading';

const Wrapper = styled.div`
    max-width: var(--page-width);
    margin: auto;
    > button {
        margin: ${defaultTheme.spacing.md} 0 ${defaultTheme.spacing.md} auto;
    }
`;
function BackArrow({className}) {
    return (
        <Button className={className} onClick={historyBack} leftSlot={<img src={Back} alt="back" />} />
    )
}
const BackArrowStyled = styled(BackArrow)`
        background-color: transparent;
        fill: #6d7175;
        border: 0.0625rem solid #babfc3 ;
    `;

function historyBack() {
    // eslint-disable-next-line no-restricted-globals
    history.back()
}

const StyledAddMedia = styled(Button)`
   color: #3448c5;
   border-radius: 4px;
   div {
     font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
     color: #ffffff;
     font-size: 12px;
   }
`;

export default function AppExt(props) {
    let { getBackendUrl, postBackendUrl, cldStatus } = useContext(AppContext);
    const [media, setMedia] = useState(null);
    const [mediaChanged, setMediaChanged] = useState(false);
    const [cld, setCld] = useState(null);
    const {show} = useToast()

    async function getOauthToken() {
        let res = await getBackendUrl('cld/token');
        if (res.ok) {
            return res.token;
        } else {
            console.log(res);
            //TODO: error
        }
    }
    const { id } = props;
    async function openMlw() {
        const token = await getOauthToken()
        if (token) {
            let base = document.location.origin
            if (process.env.NODE_ENV === 'development') {
                base = "https://localhost:3000"
            }
            if (window.newTab && !window.newTab.closed) {
                window.newTab.focus();
            } else {
                window.newTab = window.open(
                    `${base}/mlw?token=${token}&origin=${document.location.origin}`,
                    '_blank'
                );
            }
        } else {
            show('Error getting token', {error: true})
        }
    }
    async function getCldConfig() {
        if (process.env.REACT_APP_DEV) {
            cld.current = new Cloudinary({
                cloud: {
                    cloudName: 'yaniv-as',
                },
            });
            return;
        }
        let cldConfig = await getBackendUrl('sync/get-config');
        if (cldConfig.ok) {
            let c = new Cloudinary({
                cloud: {
                    cloudName: cldConfig.configuration.cloudName,
                },
            });
            setCld(c)
        } else {
            show('Error getting cloud configuration', {error: true})
        }
    }

    async function getMedia() {
        if (process.env.REACT_APP_DEV) {
            let m = JSON.parse(process.env.REACT_APP_PRODUCTS_MOCK);
            setMedia(m.media);
            return;
        }
        let mediaRes = await getBackendUrl(`shopify/product-media?pid=${id}`);
        if (mediaRes.ok) {
            if (mediaRes.media) {
                setMedia(mediaRes.media);
                if (mediaRes.media.length === 0) {
                    show('No media found. You can add media directly from Cloudinary by choosing Add Media');
                }
            } else {
                show('No media found for product', {error: true});
            }
        } else {
            show('Error getting media for product', {error: true});
        }
    }

    async function mediaAndConf() {
        await Promise.allSettled([getMedia(), getCldConfig()])
    }

    useEffect(() => {
        window.addEventListener('message', (ev) => {
            let good = ev.origin === document.location.origin;
            if (process.env.NODE_ENV === 'development') {
                good = true
            }
            if (good) {
                let data = ev.data;
                if (data.messageType === 'assets') {
                    addMediaReq(data.assets);
                }
            }
        });
    }, [])

    useEffect(() => {
        if (cldStatus !== null && cldStatus !== 'get') {
            mediaAndConf()
        }
    }, [cldStatus]);

    const debouncedServerUpdate = useDebouncedCallback(async (med) => {
        await updateMedia()
    }, 3000)

    useEffect(() => {
        if (media !== null) {
        // skip the first media set or explicit add and delete
        if (mediaChanged) {
            debouncedServerUpdate(media)
        } else {
            setMediaChanged(true)
        }
    }
    }, [media, debouncedServerUpdate])

    async function updateMedia() {
        let req = {
            pid: id,
            media: media,
        };
        let res = await postBackendUrl('shopify/update-media', req);
        if (res.ok) {
            show('Product media updated');
        } else {
            show('Error updating media', {error: true});
        }
    }

    async function addMediaReq(assets) {
        const media = assets.map((asset) => {
            asset.type = asset.resource_type;
            return asset
        })
        let req = {
            pid: id,
            media: media,
        };
        let res = await postBackendUrl('shopify/add-media', req);
        if (res.ok) {
            setMediaChanged(false)
            setMedia(res.media);
        } else {
            show('Error adding media', {duration: 2000, error: true})
        }
    }

    const showLoading = !(media && cld)

    return (
        <>
            {showLoading && <Loading />}
            {media !== null && cld &&
                <Wrapper>
                    <div className={'navagation'}>
                        <BackArrowStyled />
                    </div>
                    <StyledAddMedia onClick={openMlw}>Add Media</StyledAddMedia>
                    <CldMediaCards id={id} media={media} setMedia={setMedia} productId={id} setMediaChanged={setMediaChanged} cld={cld} />
                </Wrapper>}
        </>
    );
}
